import React from 'react'
import { rem } from 'polished'
import styled from 'styled-components'

import LargeContentToggle from 'components/Common/LargeContentToggle'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import { mediaQueryUp } from 'components/utils/breakpoint'

const Root = styled.div`
  padding: ${rem(12)} ${rem(20)};
  break-inside: avoid-page;

  ${mediaQueryUp.tablet} {
    padding: ${rem(12)} ${rem(40)};
  }

  &:first-child {
    padding-top: ${rem(20)};
  }

  &:last-child {
    padding-bottom: ${rem(20)};
  }
`

interface Props {
  content: string
}

function Notes({ content }: Props) {
  return (
    <Root>
      <LargeContentToggle
        maxHeight={210}
        collapsedHeight={132}
        showMoreText="Read more"
        showLessText="Read less"
        showChevron={false}
      >
        <MarkdownRender content={content} type="compact" fontSize="medium" />
      </LargeContentToggle>
    </Root>
  )
}

export default Notes
